import { render } from "./RareDiseaseView.vue?vue&type=template&id=007591d4"
import script from "./RareDiseaseView.vue?vue&type=script&lang=js"
export * from "./RareDiseaseView.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__